import { navLinks, categories } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="lg:pr-6">
            <a href="#hero" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-background-50/15 text-xl">
                🍉
              </span>
              <span className="flex items-baseline gap-1 font-heading">
                <span className="text-2xl leading-none text-background-50">52</span>
                <span className="text-2xl leading-none">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-50/70">
              表情包、沙雕图、梗图、头像、壁纸与周边衍生持续更新。存图自用或斗图都合适，
              让你在瓜田里聊得更有梗。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-douban-line", label: "豆瓣" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#about"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-background-50/80 hover:bg-secondary-500 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* 站点导航 */}
          <div>
            <h4 className="font-heading text-lg text-background-50">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-50/70 transition-colors hover:text-secondary-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 分区 */}
          <div>
            <h4 className="font-heading text-lg text-background-50">内容分区</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {categories.map((c) => (
                <li key={c.key}>
                  <a
                    href={`#${c.key}`}
                    className="flex items-center gap-2 text-sm text-background-50/70 transition-colors hover:text-secondary-300 cursor-pointer"
                  >
                    <i className={`${c.icon} text-accent-300`} /> {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系方式 */}
          <div>
            <h4 className="font-heading text-lg text-background-50">找我们聊聊</h4>
            <p className="mt-4 text-sm text-background-50/70">投稿、合作、意见反馈，欢迎来信：</p>
            <a
              href="mailto:hello@52chigua.cn"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-background-50/10 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-secondary-500 hover:text-foreground-950 cursor-pointer"
            >
              <i className="ri-mail-send-line" /> hello@52chigua.cn
            </a>
            <p className="mt-4 text-xs leading-relaxed text-background-50/50">
              工作日 9:00 – 19:00 在线
              <br />
              收到后通常在 1 个工作日内回复
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/15">
        <div className="mx-auto flex max-w-[1200px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-background-50/55 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 52吃瓜 · 本站表情素材仅供个人存图与聊天斗图使用</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-fill text-primary-400" /> 吃瓜快乐，玩梗有度
          </p>
        </div>
      </div>
    </footer>
  );
}